<template>
  <section class="accordion">
    <div class="tab">
      <input type="checkbox" name="accordion-1" :id="checkboxId">
      <label :for="checkboxId" class="tab__label">
        <div class="tab__label-title-container">
          <span>{{$t(item.title)}}</span>
          <span v-if="item.isBFCM" class="bfcm-tag">BFCM</span>
        </div>
        <div class="icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.15976 9.14645C6.37277 8.95118 6.71814 8.95118 6.93115 9.14645L12 13.7929L17.0689 9.14645C17.2819 8.95118 17.6272 8.95118 17.8402 9.14645C18.0533 9.34171 18.0533 9.65829 17.8402 9.85355L12.3857 14.8536C12.1727 15.0488 11.8273 15.0488 11.6143 14.8536L6.15976 9.85355C5.94675 9.65829 5.94675 9.34171 6.15976 9.14645Z" fill="#676767"/>
          </svg>
        </div>
      </label>
      <div class="tab__content">
        <p v-html="$t(item.description)"></p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "PricingAccordionItem",
  props: {
    index: {
      type: Number,
      required: true
    },
    item: {
      type: Object
    }
  },
  computed: {
    checkboxId() {
      return `gf-pricing-accordion-${this.index}`
    }
  }
}
</script>

<style lang="scss" scoped>
.accordion {
  box-sizing: border-box;
  padding-bottom: 24px;
  --secondary: #ff5252;
  --background: #eee;
  --highlight: #ffda79;
  /* Theme color */
  --theme: #227093;
  display: flex;
  color: #212121;
  place-items: start;
  border-bottom: 1px solid #49494910;
  margin-bottom: 24px;
  .tab {
    width: 100%;
  }
}

.bfcm-tag {
  width: 51px;
  height: 20px;
  border-radius: 3px;
  background: #D8E1FF;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0008C9;
  font-size: 12px;
  font-weight: 500;
}

/* Core styles/functionality */
.tab input {
  position: absolute;
  opacity: 0;
  z-index: -1;
}
.tab__content {
  box-sizing: border-box;
  max-height: 0;
  overflow: hidden;
  transition: all 0.35s;
  color: #212121;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
.tab input:checked ~ .tab__content {
  max-height: 10rem;
  padding-top: 16px;
}
.tab input:checked ~ .tab__label > .icon {
  transform: rotate(-180deg);
}
.tab__label {
  display: flex;
  align-items: start;
  gap: 16px;
  cursor: pointer;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  user-select: none;
  &:hover {
    color: #3C67FF;
  }
  .icon {
    transform: rotate(0deg);
    transition: all 0.35s;
    display: flex;
  }
  &-title-container {
    align-items: center;
    gap: 8px;
    display: flex;
  }
}
.tab__label {
  justify-content: space-between;
}
.tab__content p {
  margin: 0;
}


</style>
